import { generatePermissionForEntity } from '../util';
export const DELIVERY_PERMISSIONS = generatePermissionForEntity('DELIVERY');
//# sourceMappingURL=delivery.js.map